var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-body" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading != 0,
            expression: "loading != 0"
          }
        ],
        staticClass: "row"
      },
      [
        _c(
          "div",
          { staticClass: "col-sm-12" },
          [
            _c("h2", [_vm._v(_vm._s(_vm.trans("form.please_wait")) + "...")]),
            _vm._v(" "),
            _c("ring-loader")
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading == 0,
            expression: "loading == 0"
          }
        ]
      },
      [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-sm-12" },
            [
              _c("singleselect", {
                attrs: {
                  checked: _vm.companyClient.client
                    ? _vm.companyClient.client.id
                    : null,
                  name: "client",
                  label: "email",
                  title: _vm.trans("company_client.entity.client.email"),
                  "allow-empty": false,
                  errors: _vm.form.options.errors,
                  options: _vm.clients
                },
                on: { search: _vm.findClients, dispatch: _vm.clientSelected }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-12" },
            [
              _c("checkbox", {
                attrs: {
                  name: "active",
                  checked: _vm.companyClient.isActive,
                  label: _vm.trans("company_client.entity.active")
                },
                model: {
                  value: _vm.companyClient.isActive,
                  callback: function($$v) {
                    _vm.$set(_vm.companyClient, "isActive", $$v)
                  },
                  expression: "companyClient.isActive"
                }
              })
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6faa1545", { render: render, staticRenderFns: staticRenderFns })
  }
}